import { Box, Divider } from '@mui/material';
import CostCenterSettings from './components/CostCenterSettings';

export const MATCH_SETTINGS_GROUP = 'self-match';
export const DTR_SETTINGS_GROUP = 'dtr';
export const TRAVELCOST_SETTINGS_GROUP = 'exclude-travelcost-calculation';
export const ROSTERSTATE_SETTINGS_GROUP = 'roster-state-settings';

const Settings = ({ costCenterId }) => {
  return (
    <Box display="flex" flexDirection="row" width={1} gap={4}>
      <Box width={1}>
        <CostCenterSettings
          settingsGroup={MATCH_SETTINGS_GROUP}
          costCenterId={costCenterId}
        />
      </Box>
      <Box width={1}>
        <CostCenterSettings
          settingsGroup={DTR_SETTINGS_GROUP}
          costCenterId={costCenterId}
        />
        <Divider sx={{ my: 3 }} />
        <CostCenterSettings
          settingsGroup={TRAVELCOST_SETTINGS_GROUP}
          costCenterId={costCenterId}
        />
        <Divider sx={{ mt: 3, mb: 6 }} />
        <CostCenterSettings
          settingsGroup={ROSTERSTATE_SETTINGS_GROUP}
          costCenterId={costCenterId}
        />
      </Box>
    </Box>
  );
};

export default Settings;
